module.exports = __webpack_public_path__ + "static/media/background.600ef159.png";